export default __webpack_public_path__ + "static/media/benefit-1@2x.d2b94df9.png";